/**
 * Copyright (C) 2021 - 2026 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { FormFieldModule } from '../../components/form/form-field/form-field.module';
import { InputFieldModule } from '../../components/form/input-field/input-field.module';
import { DevLoginService } from '../../services/dev-login/dev-login.service';
import { DevLoginComponent } from './dev-login.component';
import { DevLoginRoutingModule } from './dev-login.routing.module';

@NgModule({
	declarations: [DevLoginComponent],
	imports: [
		CommonModule,
		DevLoginRoutingModule,
		FormFieldModule,
		InputFieldModule,
		MatProgressSpinnerModule,
		MatIconModule,
		ReactiveFormsModule,
		TranslateModule,
		MatButtonModule,
	],
	providers: [DevLoginService, provideHttpClient(withInterceptorsFromDi())],
})
export class DevLoginModule {}
